import { DispatchAddressController } from './dispatchAddress.controller';
import template from './dispatchAddress.html';

export const dispatchAddressComponent = {
  name: 'dispatchAddress',
  restrict: 'E',
  template,
  controller: DispatchAddressController,
  controllerAs: 'vm',
  bindings: {
    descriptionTitle: '@',
    descriptionText: '@',
    model: '=',
    form: '=',
  },
};
